import { AuthService, UploadService } from '@/app/core';
import { Adjunto } from '@/app/models/interface/adjunto.model';
import { Usuario } from '@/app/models/interface/usuario.model';
import { environment } from '@/environments/environment';
import { Component, EventEmitter, inject, Output } from '@angular/core';

@Component({
  selector: 'c-modal-repo',
  templateUrl: './modal-repo.component.html',
  styleUrl: './modal-repo.component.css',
  standalone: false,
})
export class ModalRepoComponent {
  private readonly auth = inject(AuthService);
  visible = false;

  url = environment.images;

  toggleImagen(archivo: Adjunto) {
    return archivo.adjunto.includes('.pdf')
      ? 'png/pdf.png'
      : archivo.adjunto.includes('.mp4')
        ? 'png/video.png'
        : 'png/doc.png';
  }

  esImagen(archivo: Adjunto) {
    return (
      archivo.adjunto.includes('.jpg') ||
      archivo.adjunto.includes('.jpeg') ||
      archivo.adjunto.includes('.png') ||
      archivo.adjunto.includes('.gif')
    );
  }

  adjuntos: Adjunto[] = [];

  private readonly uploadService = inject(UploadService);

  async open() {
    this.visible = true;
    const usuario: Usuario | null = await this.auth.returnUserInfo();
    this.uploadService.getFiles(usuario?.id_usuario ?? 0).subscribe((data) => {
      this.adjuntos = data;
    });
  }

  eliminarArchivo(id: string) {
    this.uploadService.deleteFile(id).subscribe((data) => {
      if (data) this.adjuntos = this.adjuntos.filter((i) => i.id !== id);
    });
  }

  @Output() emitirAdjunto = new EventEmitter<Adjunto>();
  onEmitirAdjunto(adjunto: Adjunto) {
    this.emitirAdjunto.emit(adjunto);
    this.visible = false;
  }
}
